import { useState, useEffect } from 'react';
import { fetchFunifierItems, convertFunifierToAvatarItem, debugFunifierStructure } from '../services/funifierApi';
import type { AvatarItem } from '../types/types';

export function useFunifierItems() {
  const [items, setItems] = useState<AvatarItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadItems = async () => {
    try {
      setLoading(true);
      setError(null);
      
            const funifierItems = await fetchFunifierItems();
            
      debugFunifierStructure(funifierItems, 2);
      
      
      const convertedItems = funifierItems
        .map((item, index) => {
          try {
            return convertFunifierToAvatarItem(item);
          } catch (error) {
                        return null;
          }
        })
        .filter((item): item is NonNullable<typeof item> => item !== null);
      
            setItems(convertedItems);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro desconhecido');
          } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadItems();
  }, []);

  return { items, loading, error, refetch: loadItems };
}
